<template>
  <div id="datashowtype">

  <div class="areaBlock" v-if="platform=='zsmkj'">
	  <p class="title">
		  {{$t('datashowtype.faceBonesContent')}}
	  </p>
	  <quilleditor
			  class="editerBox"
			  v-model="face_bones_content"
			  ref="myTextEditor1"
			  :options="editorOption1"
			  @change="onChange(1)"
	  >
		  <div id="toolbar1" slot="toolbar">
			  <select class="ql-size">
				  <option value="small"></option>
				  <option selected></option>
				  <option value="large"></option>
				  <option value="huge"></option>
			  </select>
			  <span class="ql-formats">
                <button class="ql-script" value="sub"></button>
              </span>
			  <span class="ql-formats">
                <button class="ql-script" value="super"></button>
              </span>
			  <span class="ql-formats">
                <button type="button" class="ql-bold"></button>
              </span>
			  <span class="ql-formats">
                <button type="button" class="ql-italic"></button>
              </span>
			  <span class="ql-formats">
                <button type="button" class="ql-blockquote"></button>
              </span>
			  <span class="ql-formats">
                <button type="button" class="ql-list" value="ordered"></button>
              </span>
			  <span class="ql-formats">
                <button type="button" class="ql-list" value="bullet"></button>
              </span>
			  <span class="ql-formats">
                <button type="button" class="ql-link"></button>
              </span>
			  <span class="ql-formats">
                <button type="button" @click="imgClick(1)" style="outline:none">
                  <svg viewBox="0 0 18 18">
                    <rect class="ql-stroke" height="10" width="12" x="3" y="4" />
                    <circle class="ql-fill" cx="6" cy="7" r="1" />
                    <polyline
							class="ql-even ql-fill"
							points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"
					/>
                  </svg>
                </button>
              </span>
		  </div>
	  </quilleditor>
  </div>
	  <div class="areaBlock" v-if="platform=='zsmkj'">
		  <p class="title">
			  {{$t('datashowtype.faceMuscleContent')}}
		  </p>
		  <quilleditor
				  class="editerBox"
				  v-model="face_muscle_content"
				  ref="myTextEditor2"
				  :options="editorOption2"
				  @change="onChange(2)"
		  >
			  <div id="toolbar2" slot="toolbar">
				  <select class="ql-size">
					  <option value="small"></option>
					  <option selected></option>
					  <option value="large"></option>
					  <option value="huge"></option>
				  </select>
				  <span class="ql-formats">
                <button class="ql-script" value="sub"></button>
              </span>
				  <span class="ql-formats">
                <button class="ql-script" value="super"></button>
              </span>
				  <span class="ql-formats">
                <button type="button" class="ql-bold"></button>
              </span>
				  <span class="ql-formats">
                <button type="button" class="ql-italic"></button>
              </span>
				  <span class="ql-formats">
                <button type="button" class="ql-blockquote"></button>
              </span>
				  <span class="ql-formats">
                <button type="button" class="ql-list" value="ordered"></button>
              </span>
				  <span class="ql-formats">
                <button type="button" class="ql-list" value="bullet"></button>
              </span>
				  <span class="ql-formats">
                <button type="button" class="ql-link"></button>
              </span>
				  <span class="ql-formats">
                <button type="button" @click="imgClick(2)" style="outline:none">
                  <svg viewBox="0 0 18 18">
                    <rect class="ql-stroke" height="10" width="12" x="3" y="4" />
                    <circle class="ql-fill" cx="6" cy="7" r="1" />
                    <polyline
							class="ql-even ql-fill"
							points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"
					/>
                  </svg>
                </button>
              </span>
			  </div>
		  </quilleditor>
	  </div>

	  <div class="areaBlock" v-if="platform=='zsmkj'">
		  <p class="title">
			  {{$t('datashowtype.faceFatContent')}}
		  </p>
		  <quilleditor
				  class="editerBox"
				  v-model="face_fat_content"
				  ref="myTextEditor3"
				  :options="editorOption3"
				  @change="onChange(3)"
		  >
			  <div id="toolbar3" slot="toolbar">
				  <select class="ql-size">
					  <option value="small"></option>
					  <option selected></option>
					  <option value="large"></option>
					  <option value="huge"></option>
				  </select>
				  <span class="ql-formats">
                <button class="ql-script" value="sub"></button>
              </span>
				  <span class="ql-formats">
                <button class="ql-script" value="super"></button>
              </span>
				  <span class="ql-formats">
                <button type="button" class="ql-bold"></button>
              </span>
				  <span class="ql-formats">
                <button type="button" class="ql-italic"></button>
              </span>
				  <span class="ql-formats">
                <button type="button" class="ql-blockquote"></button>
              </span>
				  <span class="ql-formats">
                <button type="button" class="ql-list" value="ordered"></button>
              </span>
				  <span class="ql-formats">
                <button type="button" class="ql-list" value="bullet"></button>
              </span>
				  <span class="ql-formats">
                <button type="button" class="ql-link"></button>
              </span>
				  <span class="ql-formats">
                <button type="button" @click="imgClick(3)" style="outline:none">
                  <svg viewBox="0 0 18 18">
                    <rect class="ql-stroke" height="10" width="12" x="3" y="4" />
                    <circle class="ql-fill" cx="6" cy="7" r="1" />
                    <polyline
							class="ql-even ql-fill"
							points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"
					/>
                  </svg>
                </button>
              </span>
			  </div>
		  </quilleditor>
	  </div>

	  <div class="areaBlock" v-if="platform=='zsmkj'">
		  <p class="title">
			  {{$t('datashowtype.faceNetContent')}}
		  </p>
		  <quilleditor
				  class="editerBox"
				  v-model="face_net_content"
				  ref="myTextEditor4"
				  :options="editorOption4"
				  @change="onChange(4)"
		  >
			  <div id="toolbar4" slot="toolbar">
				  <select class="ql-size">
					  <option value="small"></option>
					  <option selected></option>
					  <option value="large"></option>
					  <option value="huge"></option>
				  </select>
				  <span class="ql-formats">
                <button class="ql-script" value="sub"></button>
              </span>
				  <span class="ql-formats">
                <button class="ql-script" value="super"></button>
              </span>
				  <span class="ql-formats">
                <button type="button" class="ql-bold"></button>
              </span>
				  <span class="ql-formats">
                <button type="button" class="ql-italic"></button>
              </span>
				  <span class="ql-formats">
                <button type="button" class="ql-blockquote"></button>
              </span>
				  <span class="ql-formats">
                <button type="button" class="ql-list" value="ordered"></button>
              </span>
				  <span class="ql-formats">
                <button type="button" class="ql-list" value="bullet"></button>
              </span>
				  <span class="ql-formats">
                <button type="button" class="ql-link"></button>
              </span>
				  <span class="ql-formats">
                <button type="button" @click="imgClick(4)" style="outline:none">
                  <svg viewBox="0 0 18 18">
                    <rect class="ql-stroke" height="10" width="12" x="3" y="4" />
                    <circle class="ql-fill" cx="6" cy="7" r="1" />
                    <polyline
							class="ql-even ql-fill"
							points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"
					/>
                  </svg>
                </button>
              </span>
			  </div>
		  </quilleditor>
	  </div>

	<div class="typeBlockSubmit">
		<el-button @click="submit" class="btn1 btn_blue_boder" type="primary" size="small">{{$t('datashowtype').sure}}</el-button>
	</div>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor";

export default {
  name: 'datashowtype',
  data () {
    return {
	  doing: false,
	  initConfs: null,
	  platform: null,
		editorOption1: {
			theme: "snow",
			modules: {
				toolbar: "#toolbar1",
			}
		},
        editorOption2: {
            theme: "snow",
            modules: {
                toolbar: "#toolbar2",
            }
        },
        editorOption3: {
            theme: "snow",
            modules: {
                toolbar: "#toolbar3",
            }
        },

        editorOption4: {
            theme: "snow",
            modules: {
                toolbar: "#toolbar4",
            }
        },
        face_bones_content:null,
        face_muscle_content:null,
        face_fat_content:null,
        face_net_content:null,
    }
  },
  computed: {
      editor1() {
          return this.$refs.myTextEditor1.quill;
      },
      editor2() {
          return this.$refs.myTextEditor2.quill;
      },
      editor3() {
          return this.$refs.myTextEditor3.quill;
      },
      editor4() {
          return this.$refs.myTextEditor4.quill;
      }
  },
  created () {
	  this.initConf()
  },
components: {
	quilleditor: quillEditor
},
  methods: {
	  onChange(id) {
	      if(id==1){
              this.$emit("input", this.face_bones_content);
		  }else if(id==2){
              this.$emit("input", this.face_muscle_content);
		  }else if(id==3){
              this.$emit("input", this.face_fat_content);
		  }else{
              this.$emit("input", this.face_net_content);
		  }

	  },
      imgClick(id) {
          let _this = this;
          let input = document.createElement("input")
          input.type = "file"
          input.name = this.fileName
          input.accept = "image/jpeg,image/png,image/jpg,image/gif"
          input.onchange = (e)=>{_this.onFileChange(e,id)}
          input.click()
      },
      onFileChange(e,id) {
          let fileInput = e.target;
          if (fileInput.files.length === 0) {
              return;
          }
          if (fileInput.files[0].size > this.maxUploadSize) {
              this.$alert(
                  this.$i18n.t("imagelimit2m"),
                  this.$i18n.t("imagelimit2big"),
                  {
                      confirmButtonText: this.$i18n.t("normal_sure"),
                      type: "warning"
                  }
              );
          }
          let config = {
              headers: { "Content-Type": "multipart/form-data" }
          };
          let data = new FormData();
          data.append("file", fileInput.files[0]);
          let _this = this;
          this.axios.post("/skinMgrSrv/goods/upload", data, config).then(function(response) {
              if (response.data) {
                  let editor=_this.editor1
				  if(id==2){
                      editor= _this.editor2
				  }else if(id==3){
                      editor= _this.editor3
                  }else if(id==4){
                      editor= _this.editor4
                  }
                  let ii = editor.getSelection()
                      ? editor.getSelection().index
                      : 0;
                  let allurl = response.data.imgUrl
                  if(allurl.indexOf('http') == -1){
                      allurl = _this.getBaseUrl()+'/fileSvr/get/' + allurl
                  }
                  editor.insertEmbed(ii, "image", allurl);
              }
          });
      },
	submit () {
		if (this.doing === true) {
			return false
		}
        let params = {}
        if(this.face_bones_content!=this.initConfs.face_bones_content){
            params.face_bones_content = this.face_bones_content
        }
        if(this.face_net_content!=this.initConfs.face_net_content){
            params.face_net_content = this.face_net_content
        }
        if(this.face_muscle_content!=this.initConfs.face_muscle_content){
            params.face_muscle_content = this.face_muscle_content
        }
        if(this.face_fat_content!=this.initConfs.face_fat_content){
            params.face_fat_content = this.face_fat_content
        }
        if(Object.keys(params).length==0){
            this.$message(this.$i18n.t('datashowtype').success)
			return
		}
		let dataLoadIng = this.openFullScreen()
		this.doing = true
		let _this = this
		this.axios.post('/skinMgrSrv/config/update', this.formData(params)).then(function (response) {
			_this.doing = false
			if (response.data.code == 0) {
                _this.$message(_this.$i18n.t('datashowtype').success)
			}
			setTimeout(() => {
				dataLoadIng.close()
			}, 300);
		}).catch(function(res){
            _this.doing = false
			console.log(res)
            setTimeout(() => {
                dataLoadIng.close()
            }, 300);
		});
	},
	initConf () {
		if (this.doing === true) {
			return false
		}
		let dataLoadIng = this.openFullScreen()
		this.doing = true
		let _this = this
        let data = {
            code: 'platform,face_bones_content,face_muscle_content,face_fat_content,face_net_content'
        };
        this.axios
            .post("/skinMgrSrv/config/get", this.formData(data))
            .then(function(response) {
                _this.doing = false;
                if (response.data.code === 0) {
                    if(response.data.platform){
                        _this.platform = response.data.platform
					}
                    if(response.data.face_bones_content){
                        _this.face_bones_content = response.data.face_bones_content
                    }
                    if(response.data.face_muscle_content){
                        _this.face_muscle_content = response.data.face_muscle_content
                    }
                    if(response.data.face_fat_content){
                        _this.face_fat_content = response.data.face_fat_content
                    }
                    if(response.data.face_net_content){
                        _this.face_net_content = response.data.face_net_content
                    }
                    _this.initConfs = Object.freeze(response.data)
                }
                setTimeout(() => {
                    dataLoadIng.close()
                }, 300);
            }).catch(function (res) {
            	_this.doing = false;
                console.error(res)
				setTimeout(() => {
					dataLoadIng.close()
				}, 300);
        });
	}
  }
}
</script>
<style lang="scss">
  #datashowtype{
    width: calc(100% - 40px);
	height: auto;
	background-color: #fff;
	margin: 20px;
	border-radius: 5px;
	padding-top: 60px;
	.typeBlock{
		width: 620px;
		height: 190px;
		margin: 20px 100px;
		display: flex;
		>div{
			width: 200px;
			height: 170px;
			margin: 20px 20px 0 0;
			p{
				text-align: center;
				margin-top: 10px;
			}
		}
		.title {
			width: 160px;
			font-size: 14px;
			vertical-align: center;
			margin: auto 0;

		}
	}

	  .ageBlock{
		  width: 620px;
		  margin: 20px 100px;
		  display: flex;
		  .title {
			  width: 160px;
			  font-size: 14px;
			  vertical-align: center;
			  margin: auto 0;

		  }
	  }
	  .areaBlock{
		  width: 100%;
		  height: 450px;
		  margin: 15px 100px;
		  display: flex;
		  .title {
			  width: 160px;
			  font-size: 14px;
			  vertical-align: center;
			  margin: auto 0;

		  }
		  .editerBox{
			  height: 400px;
			  width: calc(100% - 360px);
		  }
	  }
	.typeBlockSubmit{
		width: 460px;
		height: 60px;
		text-align: center;
		margin: 60px 80px;
	}
	.btn_blue_boder{
		color: #fff;
	}
  }
</style>



// WEBPACK FOOTER //
// src/config/facearchitect.vue